'use client';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import React, { Dispatch, FC, SetStateAction, useCallback } from 'react';

interface IntegrationProps {
	showPoolPassback: boolean;
	newPool: string;
	setNewPool: (pool: string) => void;
	newPassback: boolean;
	setNewPassback: (passback: boolean) => void;
	setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
	isEditMode: boolean;
	facilityIntegration: string;
	tibaActiveMType: string;
	setTibaActiveMType: Dispatch<SetStateAction<string>>;
}

export const IntegrationDetail: FC<IntegrationProps> = ({
	showPoolPassback,
	newPool,
	setNewPool,
	newPassback,
	setNewPassback,
	setHasUnsavedChanges,
	isEditMode,
	facilityIntegration,
	tibaActiveMType,
	setTibaActiveMType,
}) => {
	const getPassbackValue = useCallback((value) => {
		if (value === null) {
			return '';
		}
		return value ? 'On' : 'Off';
	}, []);

	return (
		<Grid item xs={12} sx={{ mt: 1, mb: 2 }}>
			<Box className='pca__parkerDetail-rate'>
				<h2>Integration Settings</h2>
				<Grid container spacing={2} sx={{ mt: 1 }}>
					{showPoolPassback && (
						<Grid item xs={3}>
							<TextField
								id='passback'
								select
								label='Passback'
								value={getPassbackValue(newPassback)}
								style={{ width: '100%' }}
								InputProps={{
									readOnly: !isEditMode,
								}}
								data-cy='integration-passback-select-menu'
							>
								<MenuItem
									value='On'
									onClick={() => {
										setHasUnsavedChanges(true);
										setNewPassback(true);
									}}
								>
									On
								</MenuItem>
								<MenuItem
									value='Off'
									onClick={() => {
										setHasUnsavedChanges(true);
										setNewPassback(false);
									}}
								>
									Off
								</MenuItem>
							</TextField>
						</Grid>
					)}
					{showPoolPassback && (
						<Grid item xs={3}>
							<TextField
								id='pool'
								label='Pool'
								value={newPool || ''}
								type='text'
								variant='filled'
								style={{ width: '100%' }}
								onChange={(e) => {
									setHasUnsavedChanges(true);
									setNewPool(e.target.value);
								}}
								InputProps={{
									readOnly: !isEditMode,
								}}
								inputProps={{
									'data-cy': 'integration-pool-input',
								}}
							/>
						</Grid>
					)}

					{facilityIntegration === 'TIBA' && (
						<Grid item xs={3}>
							<TextField
								select
								fullWidth
								value={tibaActiveMType}
								label='Tiba Active mType'
								onChange={(event) => {
									setHasUnsavedChanges(true);
									setTibaActiveMType(event.target.value);
								}}
								InputProps={{
									readOnly: !isEditMode,
								}}
							>
								<MenuItem value='2'>Standard</MenuItem>
								<MenuItem value='8'>Resider</MenuItem>
								<MenuItem value='4'>Master</MenuItem>
								<MenuItem value='1'>Units</MenuItem>
							</TextField>
						</Grid>
					)}
				</Grid>
			</Box>
		</Grid>
	);
};
